import { useParams } from "react-router-dom";
import Login from "../Login";

/**
 *
 * @returns receives the request to process the QR code.  Accepts the encrypted code, then forwards to login page for further processing
 */
const UseTardyQr = () => {
  const { code } = useParams();
  return <Login qrType="score.tardy.qr" qrCode={code} />;
};

export default UseTardyQr;
